













































































































import { FinanceType } from "@/enums/enums";
import { NewObject } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DropdownVatType from "./componentItemProduct/DropdownVatType.vue";
import DropdownAccountId from "./componentItemProduct/DropdownAccountId.vue";
import DropdownTaxWithheld from "./componentItemProduct/DropdownTaxWithheld.vue";
import DropdownProductId from "./componentItemProduct/DropdownProductId.vue";

const StoreTransaction = namespace("Transaction");

@Component({ components: { DropdownVatType, DropdownAccountId, DropdownTaxWithheld, DropdownProductId } })
export default class ItemProduct extends Vue {
  @Prop({}) readonly index!: number;
  @Prop({}) readonly transactionItem!: any;
  @Prop({}) readonly transactionCreate!: any;
  @Prop({}) readonly toggleExpandAndCollapseAll!: boolean;

  private showContent = true;

  @StoreTransaction.Action
  private DoRemoveTransactionItem!: (input: any) => void;
  @StoreTransaction.Mutation
  private MutationOnChangeTransactionItem!: (transactionCreate: any) => void;
  @StoreTransaction.Mutation
  private MutationOnHumanEventChangeTransactionItem!: (transactionCreate: any) => void;
  @StoreTransaction.Mutation
  private MutationCheckErrorValueInputForCreateTransaction!: (transactionCreate: any) => void;

  @Watch("toggleExpandAndCollapseAll")
  toggleExpandAndCollapseAllChanged(newVal: boolean) {
    if (newVal) {
      this.OpenContent();
    } else {
      this.CloseContent();
    }
  }

  public ToggleShowContent() {
    this.showContent = this.showContent ? false : true;
  }

  public OpenContent() {
    this.showContent = true;
  }

  public CloseContent() {
    this.showContent = false;
  }

  public RemoveTransactionItem(index: number) {
    this.DoRemoveTransactionItem({ transactionCreate: this.transactionCreate, index: this.index });
  }

  public OnChangeTransactionItem(humanEvent = false) {
    if (humanEvent === true) {
      this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
    } else {
      this.MutationOnChangeTransactionItem(this.transactionCreate);
    }
  }

  public OnBlurTransactionItemAmountInput(index: number) {
    this.transactionCreate.transactionItemList[index].amount.value = this.transactionCreate.transactionItemList[
      index
    ].amount.value.ToPeakTransactionItemFormat();

    this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
  }

  public OnBlurTransactionItemPriceInput(index: number) {
    this.transactionCreate.transactionItemList[index].price.value = this.transactionCreate.transactionItemList[
      index
    ].price.value.ToPeakTransactionItemFormat();

    this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
  }

  public OnBlurTransactionItemDiscountInput(index: number) {
    this.transactionCreate.transactionItemList[index].discount.value = this.transactionCreate.transactionItemList[
      index
    ].discount.value.ToPeakTransactionItemFormat();

    this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
  }

  public OnKeyTransactionItem() {
    this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
  }
  public CheckErrorValueInputForCreateTransaction() {
    this.MutationCheckErrorValueInputForCreateTransaction(this.transactionCreate);
  }
  public IsShowdiscount() {
    if (this.transactionCreate.financeType == FinanceType.InFlow) {
      return true;
    } else {
      return false;
    }
  }
}
